export const GET_GROUPS = 'GET_GROUPS';
export const GOT_GROUPS = 'GOT_GROUPS';
export const ERROR_GETTING_GROUPS = 'ERROR_GETTING_GROUPS';

export const GET_GROUP_DETAILS = 'GET_GROUP_ROOM_DETAILS';
export const GOT_GROUP_DETAILS = 'GOT_GROUP_DETAILS';

export const GET_GROUPS_WITH_PERMISSION = 'GET_GROUPS_WITH_PERMISSION';
export const GOT_GROUPS_WITH_PERMISSION = 'GOT_GROUPS_WITH_PERMISSION';
export const GOT_GROUPS_WITH_CREATE_PERMISSION = 'GOT_GROUPS_WITH_CREATE_PERMISSION';

export const UPDATE_GROUP_FORM = 'UPDATE_GROUP_FORM';
export const RESET_GROUP_FORM = 'RESET_GROUP_FORM';
export const CLICKED_NEW_GROUP = 'CLICKED_NEW_GROUP';

export const UPDATE_GROUP = 'UPDATE_GROUP';
export const UPDATED_GROUP = 'UPDATED_GROUP';
export const CLICKED_UPDATE_GROUP = 'CLICKED_UPDATE_GROUP';

export const DELETE_GROUP = 'DELETE_GROUP';
export const DELETED_GROUP = 'DELETED_GROUP';
export const RESET_GROUP = 'RESET_GROUP';

export const RESET_SAVING_FLAG = 'RESET_SAVING_FLAG';

export const CREATE_GROUP = 'CREATE_GROUP';
export const CREATED_GROUP = 'CREATED_GROUP';

export const UPDATE_GROUP_SEARCH = 'UPDATE_GROUP_SEARCH';

import { displayGlobalMessage } from '../actions/globalMessage';

import { getAuthHeaders } from '../businessLogic/authorizator';

//if permission is sent empty, then we load all the groups based upon the logged in user viewable groups.

export function getGroupsWithPermission(permission, cb) {
  return (dispatch) => {
    dispatch({ type: GET_GROUPS_WITH_PERMISSION });
    var apiPart = 'groups';
    if (permission)
      //if some Permission param is being sent
      apiPart += '/' + permission;

    // TODO - Use fetchInterceptor, when redesigning meeting rooms ui
    fetch(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      headers: getAuthHeaders(),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        let res = null;

        if (permission == APP.LANGUAGE.Permission.CREATE_MEETING_ROOM)
          res = dispatch({
            type: GOT_GROUPS_WITH_CREATE_PERMISSION,
            data: data,
          });

        if (cb) cb();
        return res;
      })
      .catch((err) => console.error('There was an error getting the groups', err.toString()));
  };
}

export function getGroups(cb) {
  return (dispatch) => {
    console.log('Fetching Groups');
    dispatch({ type: GET_GROUPS });

    // TODO - Use fetchInterceptor, when redesigning meeting rooms ui
    fetch(window.APP.CONFIGURATION.VCCAPI + '/groups', {
      headers: getAuthHeaders(),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        let res = dispatch({ type: GOT_GROUPS, data: data });
        if (cb) cb();
        return res;
      })
      .catch((err) => console.error('There was an error getting the groups', err.toString()));
  };
}

export function getGroupDetails(groupId, cb) {
  return (dispatch) => {
    dispatch({ type: GET_GROUP_DETAILS });

    // TODO - Use fetchInterceptor, when redesigning meeting rooms ui
    fetch(window.APP.CONFIGURATION.VCCAPI + 'groups/' + groupId, {
      headers: getAuthHeaders(),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        let res = dispatch({ type: GOT_GROUP_DETAILS, data: data });
        if (cb) cb();
        return res;
      })
      .catch((err) => console.error('There was an API error', err.toString()));
  };
}

export function deleteGroup(groupForm, cb) {
  return (dispatch) => {
    dispatch({ type: DELETE_GROUP });

    // TODO - Use fetchInterceptor, when redesigning meeting rooms ui
    fetch(window.APP.CONFIGURATION.VCCAPI + 'groups/' + groupForm.id, {
      headers: getAuthHeaders(),
      method: 'DELETE',
    })
      .then((response) => {
        if (!response.ok) throw Error(response.statusText);
      })
      .then((data) => {
        let res = dispatch({ type: DELETED_GROUP, data: groupForm });

        var successMessage = APP.LANGUAGE.DeleteGroup.DeleteGroupSuccess.replace('##groupName##', groupForm.name);
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (cb) cb();
        return res;
      })
      .catch((err) => {
        var error =
          APP.LANGUAGE.ServerErrors[err.message] ||
          APP.LANGUAGE.Errors[err.message] ||
          APP.LANGUAGE.ServerErrors.GeneralApiError;
        // var error = error ? error : APP.LANGUAGE.ServerErrors.GeneralApiError;//will replace it from generic message
        dispatch(
          displayGlobalMessage({
            text: error,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: false,
          })
        );
        dispatch({ type: RESET_SAVING_FLAG }); //TODO: should use organisation specific reset fetching flag
        console.error('There was an API error', err.toString());
      });
  };
}

export function createGroup(groupFormData, cb) {
  return (dispatch) => {
    dispatch({ type: CREATE_GROUP });

    // TODO - Use fetchInterceptor, when redesigning meeting rooms ui
    fetch(window.APP.CONFIGURATION.VCCAPI + 'groups', {
      method: 'POST',
      body: JSON.stringify(groupFormData),
      headers: getAuthHeaders(),
    })
      .then((response) => {
        if (response.ok) return response.json();
        throw Error(response.statusText);
      })
      .then((data) => {
        if (cb) cb();
        dispatch({ type: CREATED_GROUP, data: data });
        var successMessage = APP.LANGUAGE.CreateUpdateGroup.CreateGroupSuccess.replace(
          '##groupName##',
          groupFormData.name
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        var error =
          APP.LANGUAGE.ServerErrors[err.message] ||
          APP.LANGUAGE.Errors[err.message] ||
          APP.LANGUAGE.ServerErrors.GeneralApiError;
        // var error = error ? error : APP.LANGUAGE.ServerErrors.GeneralApiError;//will replace it from generic message
        dispatch(
          displayGlobalMessage({
            text: error,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: false,
          })
        );
        dispatch({ type: RESET_SAVING_FLAG }); //TODO: should use organisation specific reset fetching flag
        console.error('There was an API error', err.toString());
      });
  };
}

export function clickedNewGroup(groupId) {
  return (dispatch) => {
    dispatch({ type: CLICKED_NEW_GROUP });
  };
}

export function clickedUpdateGroup(groupId) {
  return (dispatch) => {
    dispatch({ type: CLICKED_UPDATE_GROUP });
  };
}

export function updateGroup(groupFormData, cb) {
  return (dispatch) => {
    dispatch({ type: UPDATE_GROUP });

    // TODO - Use fetchInterceptor, when redesigning meeting rooms ui
    fetch(window.APP.CONFIGURATION.VCCAPI + 'groups/' + groupFormData.id, {
      method: 'PUT',
      body: JSON.stringify(groupFormData),
      headers: getAuthHeaders(),
    })
      .then((response) => {
        if (!response.ok) throw Error(response.statusText);
      })
      .then((data) => {
        if (cb) cb();
        var successMessage = APP.LANGUAGE.CreateUpdateGroup.UpdateGroupSuccess.replace(
          '##groupName##',
          groupFormData.name
        );
        dispatch({ type: UPDATED_GROUP, data: groupFormData }); //dispatching client groupFormData
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        var error =
          APP.LANGUAGE.ServerErrors[err.message] ||
          APP.LANGUAGE.Errors[err.message] ||
          APP.LANGUAGE.ServerErrors.GeneralApiError;
        dispatch(
          displayGlobalMessage({
            text: error,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: false,
          })
        );
        dispatch({ type: RESET_SAVING_FLAG }); //TODO: should use organisation specific reset fetching flag
        console.error('There was an API error', err.toString());
      });
  };
}

export function resetGroupForm() {
  return (dispatch) => {
    dispatch({ type: RESET_GROUP_FORM });
  };
}

export function updateGroupForm(updatedGroupForm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_GROUP_FORM, data: updatedGroupForm });
  };
}

export function updateGroupSearch(searchTerm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_GROUP_SEARCH, data: searchTerm });
  };
}
